import app from './app'
import user from './user'
import dashboard from './dashboard'
import admin from './admin'

export {
    app,
    user,
    dashboard,
    admin
}


// WEBPACK FOOTER //
// ./src/new_reducers/index.js